/**
 * Merges sponsor mapping into client data.
 * Each client object gets a `sponsors` array (or undefined if none).
 * 
 * @param {Array} clients - Array of client objects (must have client_name)
 * @param {Object} sponsorMap - { [clientName]: [sponsor1, sponsor2, ...], ... }
 * @returns {Array} New array of client objects with sponsors
 */
export function mergeSponsorsIntoClients(clients, sponsorMap) {
  if (!Array.isArray(clients) || !sponsorMap) return clients;
  return clients.map(client => ({
    ...client,
    sponsors: sponsorMap[client.client_name] || []
  }));
}
